import React from 'react';

/**
 * Кривая — компактный график динамики.
 * (По-русски «sparkline», но мы зовём это «кривая».)
 */
export default function Curve({ values = [], height = 40, color = 'gold' }) {
  const w = 100;
  const h = height;
  if (!values.length) {
    return <svg className="curve-svg" viewBox={`0 0 ${w} ${h}`} width="100%" height={h} preserveAspectRatio="none" />;
  }
  const max = Math.max(1, ...values);
  const step = w / Math.max(1, values.length - 1);
  const pts = values.map((v, i) => {
    const x = i * step;
    const y = h - (v / max) * (h - 4) - 2;
    return [x, y];
  });
  const linePath = pts.map(([x, y], i) => (i === 0 ? `M ${x} ${y}` : `L ${x} ${y}`)).join(' ');
  const areaPath = `${linePath} L ${pts[pts.length - 1][0]} ${h} L 0 ${h} Z`;
  return (
    <svg className="curve-svg" viewBox={`0 0 ${w} ${h}`} width="100%" height={h} preserveAspectRatio="none">
      <path d={areaPath} className={`area ${color === 'wine' ? 'wine' : ''}`} />
      <path d={linePath} className={`line ${color === 'wine' ? 'wine' : ''}`} />
    </svg>
  );
}
